import axios from 'axios';

const apiBling = axios.create({
  baseURL: process.env.REACT_APP_BLING_URL,
  timeout: 90000,
});

export default apiBling;
